import React from "react";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import AppStateModel from "../../../models/appStateModel";
import {useDispatch, useSelector} from "react-redux";
import ReactSelect from "react-select";
import Select from "react-select";
import {setShipmentsCriteriaAsync} from "../../../actions/shipmentsActions";
import LookupModel from "../../../models/lookupModel";

interface IProps {
    visible: boolean;
    onHide: () => any;
    onDone: (ids: string[], courierId: string, customerId: string) => void;
    title: string;
    submitButton: string;
    selectedIds: string[];
    allowedStatuses?: string[];
}

const AssignForDeliveryModal = (props: IProps) => {
    const dispatch = useDispatch()
    const [courier, setCourier] = React.useState<any>(null);
    const couriers = useSelector((state: AppStateModel) => state.Meta?.couriers);
    const customers = useSelector((state: AppStateModel) => state.Meta?.couriers);
    const meta = useSelector((state: AppStateModel) => state.Meta);
    const [selectedCustomer, setSelectedCustomer] = React.useState<LookupModel | undefined>();

    const onSubmit = () => {
        props.onDone(props.selectedIds, courier!.value!, selectedCustomer?.value ?? "");
    };

    const countryCode = useSelector(
        (state: AppStateModel) => state.Profile.currentTenant?.countryCode
    );

    return (
        <Modal
            show={props.visible}
            onHide={() => props.onHide()}
            dialogClassName="modal-100w"
            aria-labelledby="example-custom-modal-styling-title"
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{display:"flex", flexDirection:"column", gap:15, width: '40%' }}>
                    <ReactSelect
                        value={courier}
                        onChange={(v) => setCourier(v)}
                        options={couriers}
                    />
                    <Select
                        key={`selectedCustomer`}
                        value={selectedCustomer}
                        options={meta?.customers ?? []}
                        isClearable
                        placeholder={'Select Customer'}
                        onChange={(selectedOption) => {
                            setSelectedCustomer({
                                label: selectedOption?.label!,
                                value: selectedOption?.value!,
                            });

                            dispatch(
                                //@ts-ignore
                                setShipmentsCriteriaAsync({
                                    //@ts-ignore
                                    CustomerId: selectedOption?.value,
                                })
                            );
                        }}
                    />
                </div>
                
            </Modal.Body>
            <Modal.Footer>
                
                <Button
                    disabled={!courier && courier == null}
                    onClick={onSubmit}
                >
                    {props.submitButton}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignForDeliveryModal;
